export default "/flying-parrot.png"